export interface Identidade {
  id: number;
  idContato: number;
  tipoIdentidade: number;
  cpf: string;
  valido: boolean;
  deletado: boolean;
}

export interface Contato {
  nome: string;
  identidade: Identidade;
}

export interface OfertaNegociacao {
  idOferta: number;
  taxaDesconto: number;
  plano: number;
  principalAcordo: number;
  taxasAcordo: number;
  custosAcordo: number;
  jurosAcordo: number;
  correcaoAcordo: number;
  valorAcordo: number;
  descontoAcordo: number;
  valorEntrada: number;
  valorParcela: number;
}

export interface Divida {
  idDividaBradesco: number;
  credorOriginal: string;
  abrevUnidadeNegocio: string;
  nomeUnidadeNegocio: string;
  idCartao: string;
  nomeProduto: string;
  tipoProduto: string;
  vinculoCliente: string;
  dataPrimeiroAtraso: string;
  valorDivida: number;
  valorCorrecaoDivida: number;
  valorJurosDivida: number;
  valorTaxasDivida: number;
  custosDivida: number;
  valorDividaAtualizada: number;
  taxaJuros: number;
  dataSaldo: string;
  dataNegociacao: string;
  metodoPagamento: any;
  infosGarantiaAuto: any[];
  ofertasNegociacao: OfertaNegociacao[];
  idVinculo: number;
  permitirAberturaNegociacao: boolean;
}

export interface AgendamentoPromessa {
  dataVencimentoEntrada: string;
  dataPrimeiraParcela: string;
}

export interface DividasCliente {
  dividas: Divida[];
  agendamentosPromessa: AgendamentoPromessa[];
}

export interface CustomerDebtRenegociationData {
  sucesso: boolean;
  contato: Contato;
  dividasCliente: DividasCliente[];
  acordosCliente: AcordoCliente[];
}

export interface StatusAcordo {
  valor: string;
  descricao: string;
}

export interface StatusPagamento {
  valor: string;
  descricao: string;
}

export interface ParcelasCartao {
  nrParcela: number;
  valor: number;
  dataVencParcela: string | null;
  statusPagamento: StatusPagamento;
  dataAtualizacaoStatusParcela: string | null;
  linhaDigitavel: string | null;
  codigoBarras: string | null;
  boletoPdf: string | null;
}

export enum TipoPlanoRenegociacaoCartao {
  A_VISTA = 'A_VISTA',
  PARCELADO = 'PARCELADO',
}

export interface AcordoCliente {
  dataAcordo: string;
  idClienteBradesco: number;
  idDividaBradesco: number;
  idAcordo: number;
  statusAcordo: StatusAcordo;
  dataAtualizacaoStatusAcordo: string;
  idCartao: string;
  idOferta: number;
  plano: number;
  nomeCliente: string;
  tipoPlano: TipoPlanoRenegociacaoCartao;
  cpf: string;
  nomeProduto: string;
  dataPrimeiroAtraso: string;
  valorDivida: number;
  valorDividaAtualizada: number;
  valorAcordo: number;
  valorParcela: number;
  valorEntrada: number;
  percentualMensalCET: number;
  valorlMensalCET: number;
  percentualAnualCET: number;
  valorAnualCET: number;
  dataVencimentoEntrada: string;
  email: string;
  telefone: string | null;
  parcelas: ParcelasCartao[];
}
